<div ngClass="container">
    <div class="container-image">
        <img src="assets/images/common/coming-soon.svg" />
    </div>
    <div class="container-main-text">Coming soon</div>
    <div class="container-text">{{ comingSoonText }}</div>
</div>
